var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, Event, html, svg, nothing } from '@sick-davinci/ce-decorators';
import { style } from './Tag.style';
import { IconRef } from '../icon/IconRef';
/**
 * A `davinci-tag` is a label that can be deleted. To be used as a slot within `davinci-tag-module`.
 * Tags are interactive elements used for classification and markup.
 * They work like keywords and allow users to quickly search and find content marked up with these keywords.
 * @example
 * ```html
 * <davinci-tag>myTag</davinci-tag>
 * ```
 * @slot {*} content of the tag
 * 
 */

export let Tag = (_dec = Component({
  tag: 'davinci-tag',
  style: [style],
  dependencies: [IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Event({
  name: 'remove'
}), _dec9 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class Tag extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "name", _descriptor, this);

    _initializerDefineProperty(this, "type", _descriptor2, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor3, this);

    _initializerDefineProperty(this, "removetag", _descriptor4, this);

    this.handleOnClick = _e => {
      this._removeTag();
    };

    this.handleEnter = event => {
      if (event.key === 'Enter' || event.key === 'Delete') {
        this._removeTag();
      }
    };
  }

  render() {
    return html`
      <div class="wrapper">
        ${this.iconSrc ? html`<davinci-icon-ref class="icon" .src="${this.iconSrc}"></davinci-icon-ref>` : nothing}
        <div class="slotwrapper">
          <slot></slot>
        </div>
        <div class="close" tabindex="0" @click = ${this.handleOnClick} @keydown = ${this.handleEnter}>
          ${svg`
          <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g  stroke="none" stroke-width="1">
              <polygon points="19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"></polygon>
            </g>
          </svg>`}
        </div>
      </div>
    `;
  }

  _removeTag() {
    this.removetag.emit(this);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'default';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "removetag", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
